export const FeaturedDragItemTypes = {
  CARD: "card",
  MEDIA: "media",
};
